<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">模型价格</div>
    </div>
    <div class="nav2">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openAdd">添加</el-button>
      <el-table :data="tableData" style="margin-top: 16px" v-loading="loading">
        <el-table-column prop="model" label="模型"></el-table-column>
        <el-table-column prop="input_price" label="输入单价（元/百万tokens）"></el-table-column>
        <el-table-column prop="output_price" label="输出单价（元/百万tokens）"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="form.id ? '编辑模型价格' : '添加模型价格'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="140px">
        <el-form-item label="模型">
          <el-input v-model="form.model" size="small"></el-input>
        </el-form-item>
        <el-form-item label="输入单价">
          <el-input v-model="form.input_price" size="small"></el-input>
        </el-form-item>
        <el-form-item label="输出单价">
          <el-input v-model="form.output_price" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      visible: false,
      form: { id: null, model: "", input_price: "", output_price: "" }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    rowsOf(res) {
      const body = res && res.data ? res.data : {};
      return body.data || [];
    },
    async getData() {
      this.loading = true;
      const res = await this.$api.crudselectListByMap({
        page: 1,
        pagesize: 500,
        table: "model_price",
        params: {}
      });
      this.tableData = this.rowsOf(res);
      this.loading = false;
    },
    openAdd() {
      this.form = { id: null, model: "", input_price: "", output_price: "" };
      this.visible = true;
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        model: row.model,
        input_price: row.input_price,
        output_price: row.output_price
      };
      this.visible = true;
    },
    async save() {
      if (!this.form.model) {
        this.$message.error("请填写模型名");
        return;
      }
      const values = {
        model: this.form.model,
        input_price: this.form.input_price,
        output_price: this.form.output_price
      };
      const res = this.form.id
        ? await this.$api.crudupdatebyid({ table: "model_price", id: this.form.id, values })
        : await this.$api.crudInsert({ table: "model_price", values });
      if (res.data && res.data.result == 1) {
        this.$message.success("保存成功");
        this.visible = false;
        this.getData();
      } else {
        this.$message.error((res.data && res.data.msg) || "保存失败");
      }
    },
    async remove(row) {
      await this.$confirm("确认删除该模型价格？", "提示", { type: "warning" });
      const res = await this.$api.crudDeletebyid({ table: "model_price", id: row.id });
      if (res.data && res.data.result == 1) {
        this.$message.success("已删除");
        this.getData();
      } else {
        this.$message.error((res.data && res.data.msg) || "删除失败");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;
  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
  }
}
.nav2 {
  background: #fff;
  margin: 16px 0;
  padding: 20px;
}
</style>
